import { ComprobanteInput } from './comprobantes/ComprobanteInput';
import { MoneyInput } from './ui/MoneyInput';
import { RadioGroup } from './ui/RadioGroup';
import type { ComprobanteFormulario } from '../hooks/useComprobanteFormulario';
import type { Deposito, OrigenDeuda } from '../utils/origenDeuda';

const AYUDA_ORIGEN: Record<OrigenDeuda, string> = {
  compra_credito: 'Boleta o factura de la compra, y el contrato o voucher del crédito si lo tienes.',
  prestamo: 'Contrato, pagaré o comprobante del depósito.',
};

interface OrigenDeudaCamposProps {
  readonly comprobante: ComprobanteFormulario;
  readonly origenDeuda: OrigenDeuda | '';
  readonly onOrigenChange: (origen: OrigenDeuda) => void;
  readonly depositado: Deposito | '';
  readonly onDepositadoChange: (depositado: Deposito) => void;
  readonly montoRecibido: number;
  readonly onMontoRecibidoChange: (monto: number) => void;
  readonly montoTotal: number;
  readonly nombreEntidad: string;
  readonly deshabilitado: boolean;
}

/** Comprobante de origen de la deuda y qué la originó; si fue un préstamo, si el dinero llegó a la cuenta. */
export const OrigenDeudaCampos: React.FC<OrigenDeudaCamposProps> = ({
  comprobante, origenDeuda, onOrigenChange, depositado, onDepositadoChange,
  montoRecibido, onMontoRecibidoChange, montoTotal, nombreEntidad, deshabilitado,
}) => (
  <>
    <ComprobanteInput
      comprobante={comprobante}
      titulo="Comprobante de origen"
      ayuda={origenDeuda ? AYUDA_ORIGEN[origenDeuda] : undefined}
      deshabilitado={deshabilitado}
    />
    <RadioGroup
      label="¿Qué originó la deuda?"
      name="origen-deuda"
      value={origenDeuda}
      onChange={(valor) => { onOrigenChange(valor as OrigenDeuda); }}
      disabled={deshabilitado}
      options={[
        { value: 'compra_credito', label: 'Compra a crédito', description: 'Muebles, electrodomésticos u otros bienes.' },
        { value: 'prestamo', label: 'Préstamo o crédito en dinero' },
      ]}
    />
    {origenDeuda === 'prestamo' && (
      <RadioGroup
        label={`¿El dinero se depositó en la cuenta de ${nombreEntidad || 'la entidad'}?`}
        name="deposito"
        orientation="horizontal"
        value={depositado}
        onChange={(valor) => { onDepositadoChange(valor as Deposito); }}
        disabled={deshabilitado}
        options={[{ value: 'si', label: 'Sí' }, { value: 'no', label: 'No' }]}
      />
    )}
    {origenDeuda === 'prestamo' && depositado === 'si' && (
      <MoneyInput
        label="Monto recibido en la cuenta"
        value={montoRecibido}
        onChange={onMontoRecibidoChange}
        min={1}
        max={montoTotal}
        disabled={deshabilitado}
        required
      />
    )}
  </>
);
